import cx from "classnames";
import classes from "./creditExpire.module.css";
import { useRouter } from "next/router";
import { Routes } from "../../routes/RouteConstants";
import { formatDateWithOrdinalSuffix } from "../../utils/creditUtils";
import CreditsExpireDashboard from "../CreditsExpireDashboard";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import { useCreditProfile } from "queries/credits/useCreditProfile";

const CreditsExpire = props => {
  const router = useRouter();
  const { query } = router;
  const { customClass = "", page = "" } = props;
  const { data = {} } = useCreditProfile(query.recruiterId);

  const {
    isCreditBetaUser,
    creditsDateOfExpiry: expiryDate = null,
    creditsGettingExpired: expiringCredits = null,
    showExpiringCredits
  } = data;
  const postJob = e => {
    e.preventDefault();
    e.stopPropagation();
    LogService.log(CREDIT_EVENTS.EXPIRING_CREDIT_POST_JOB_CLICKED, {
      page
    });
    router.push(Routes.JOB_POSTING_FORM);
  };

  // Handle cases where component should not render
  if (!isCreditBetaUser || !showExpiringCredits) return null;

  // Render CreditsExpireDashboard component if page is "dashboard"
  if (page === "dashboard") {
    return (
      <CreditsExpireDashboard
        expiringCredits={expiringCredits}
        expiryDate={formatDateWithOrdinalSuffix(expiryDate)}
        postJob={postJob}
      />
    );
  }
  return (
    <div className={cx(classes.expringCnt, "flex items-center", customClass)}>
      <div className="flex items-center">
        <img
          src="/hire/danger.svg"
          alt="danger-icon"
          height={14}
          width={14}
          className={classes.warningIcon}
        />
        {expiringCredits}
        <img
          src="/hire/coin-icon.svg"
          alt="coin"
          height={13}
          width={13}
          className={classes.coinIcon}
        />
        will expire on {formatDateWithOrdinalSuffix(expiryDate)}
      </div>
      <div>
        <span onClick={postJob} className={classes.postJob}>
          Post a job
        </span>
      </div>
    </div>
  );
};

export default CreditsExpire;
